import React from 'react';

const FilterPanel = ({ 
  clients, 
  departments, 
  selectedClient, 
  selectedDepartment, 
  onClientChange, 
  onDepartmentChange, 
  onClearFilters,
  totalCandidates,
  filteredCandidates
}) => {
  return (
    <div className="dashboard-card p-4 mb-6 fade-in">
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
        <div className="flex flex-col md:flex-row md:items-center gap-4">
          <div>
            <label htmlFor="client-filter" className="block text-sm font-medium text-gray-700 mb-1">
              Filter by Client
            </label>
            <select
              id="client-filter"
              className="bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block w-full p-2.5"
              value={selectedClient}
              onChange={(e) => onClientChange(e.target.value)}
            >
              <option value="">All Clients</option>
              {clients.map((client) => (
                <option key={client} value={client}>
                  {client}
                </option>
              ))}
            </select>
          </div>
          
          <div>
            <label htmlFor="department-filter" className="block text-sm font-medium text-gray-700 mb-1">
              Filter by Department
            </label>
            <select
              id="department-filter"
              className="bg-white border border-gray-300 text-gray-700 text-sm rounded-lg focus:ring-indigo-500 focus:border-indigo-500 block w-full p-2.5"
              value={selectedDepartment}
              onChange={(e) => onDepartmentChange(e.target.value)}
            >
              <option value="">All Departments</option>
              {departments.map((department) => (
                <option key={department} value={department}>
                  {department}
                </option>
              ))}
            </select>
          </div>
          
          {(selectedClient || selectedDepartment) && (
            <button
              onClick={onClearFilters}
              className="inline-flex items-center px-4 py-2 mt-6 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Clear Filters
            </button>
          )}
        </div>
        
        <div className="text-sm text-gray-500 flex items-center flex-wrap">
          {selectedClient || selectedDepartment ? (
            <span>
              Showing <span className="font-medium">{filteredCandidates}</span> of <span className="font-medium">{totalCandidates}</span> candidates
              {selectedClient && (
                <span className="ml-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-800">
                  Client: {selectedClient}
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onClientChange('');
                    }} 
                    className="ml-1 focus:outline-none"
                  >
                    <svg className="h-3 w-3 text-indigo-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </span>
              )}
              {selectedDepartment && (
                <span className="ml-1 inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">
                  Department: {selectedDepartment}
                  <button 
                    onClick={(e) => {
                      e.stopPropagation();
                      onDepartmentChange('');
                    }} 
                    className="ml-1 focus:outline-none"
                  >
                    <svg className="h-3 w-3 text-blue-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </span>
              )}
            </span>
          ) : (
            <span>Showing all <span className="font-medium">{totalCandidates}</span> candidates</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default FilterPanel;
